import React from 'react';
import cn from 'classnames';
import {
  FormControlLabel,
  Radio as MuiRadio,
  Checkbox as MuiCheckbox,
  ListItemText,
  RadioGroup,
  Table,
  TableBody,
  TableCell as MuiTableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import { Check as CheckIcon } from '@mui/icons-material';
import styles from '../index.module.css';

export const StyledCheckbox = withStyles({
  root: {
    color: 'black',
    '&$checked': {
      color: 'black !important',
    },
  },
  checked: {},
})(MuiCheckbox);
export const Radio = withStyles({ root: { color: 'black' }, checked: { color: 'black !important' } })(MuiRadio);
export const TableCell = withStyles({
  root: {
    borderColor: 'rgba(15, 17, 28, 0.08)',
    color: '#15171c',
    fontFamily: 'Montserrat, sans-serif',
  }
})(MuiTableCell);

export const TableHeaderCell = withStyles({
  root: {
    borderTopStyle: 'solid',
    borderTopWidth: '1px',
    fontWeight: '600',
    paddingBottom: '0 !important',
    paddingTop: '0 !important',
    whiteSpace: 'nowrap',
  }
})(TableCell);
export const Checkbox = ({ header, status, selected, onClick, disabled, setSelectAllChecked }) => (
  /* eslint-disable jsx-a11y/click-events-have-key-events */
  (
<div
    className={cn({
      [styles.checkbox]: true,
      [styles.header]: header,
      [styles.checked]: status || selected, // Apply the 'checked' class if 'status' is true or 'selected' is true
      [styles.indeterminate]: status === undefined,
      [styles.blackCheckbox]: setSelectAllChecked, // Apply the 'blackCheckbox' class when setSelectAllChecked is true
    })}
    onClick={disabled ? undefined : onClick}
/>
)
);

export const SquareCheckbox = ({ header, status, selected, onClick, disabled, setSelectAllChecked }) => (
  /* eslint-disable jsx-a11y/click-events-have-key-events */
  (
<div
    className={cn({
      [styles.squareCheckbox]: true,
      [styles.header]: header,
      [styles.checked]: status || selected,
      [styles.indeterminate]: status === undefined,
      [styles.blackCheckbox]: setSelectAllChecked,
    })}
    onClick={disabled ? undefined : onClick}
>
    {(status || selected) && (
      <CheckIcon className={styles.checkIcon} />
    )}
</div>
)
);
